import YFormColorPicker from './ColorPicker';

export { YFormColorPicker };
export default YFormColorPicker;
